import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
export class AmdDropdownComponent {
    /**
     * @param {?} changeDetectorRef
     */
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this._isContentActive = false;
    }
    /**
     * @param {?} isContentActive
     * @return {?}
     */
    set isContentActive(isContentActive) {
        this._isContentActive = isContentActive;
        this.changeDetectorRef.markForCheck();
    }
    /**
     * @return {?}
     */
    get isContentActive() {
        return this._isContentActive;
    }
    /**
     * @return {?}
     */
    open() {
        this.isContentActive = true;
    }
    /**
     * @return {?}
     */
    close() {
        this.isContentActive = false;
    }
    /**
     * @return {?}
     */
    toggle() {
        this.isContentActive = !this.isContentActive;
    }
    /**
     * @return {?}
     */
    onTriggerClicked() {
        this.toggle();
    }
    /**
     * @return {?}
     */
    onOverlayClicked() {
        this.close();
    }
}
AmdDropdownComponent.decorators = [
    { type: Component, args: [{
                selector: 'amd-dropdown',
                template: "<amd-overlay [isActive]=\"isContentActive\" [isFixed]=\"true\" (onOverlayClicked)=\"onOverlayClicked()\"> </amd-overlay> <div class=\"amd-dropdown\"> <div class=\"amd-dropdown__trigger\" (click)=\"onTriggerClicked()\"> <ng-content select=\"[amdDropdownTrigger]\"></ng-content> </div> <div class=\"amd-dropdown__content\" *ngIf=\"isContentActive\"> <ng-content select=\"[amdDropdownContent]\"></ng-content> </div> </div>",
                changeDetection: ChangeDetectionStrategy.OnPush,
                exportAs: 'amdDropdown'
            },] },
];
/**
 * @nocollapse
 */
AmdDropdownComponent.ctorParameters = () => [
    { type: ChangeDetectorRef, },
];
function AmdDropdownComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdDropdownComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdDropdownComponent.ctorParameters;
    /** @type {?} */
    AmdDropdownComponent.prototype._isContentActive;
    /** @type {?} */
    AmdDropdownComponent.prototype.changeDetectorRef;
}
//# sourceMappingURL=dropdown.component.js.map
//# sourceMappingURL=dropdown.component.js.map
